/**
 * data-btn-hide: hide button after click
 * data-action="expand", data-action="collapse": do only one action - expand or collapse
 */
$(document).on('click', '.js-m-collapse', function () {

    if ($(this).data('btn-hide')) {
        $(this).addClass('u-none');
    }

    var $target_value = $(this).data('target');
    var $target_block = $('.m-collapse--' + $(this).data('target'));


    if ($target_block.is(':visible') && $(this).data('action') !== 'expand') {
        $(document).trigger('collapseClosing', [$target_value]);
        $('[data-target="'+$target_value+'"]').removeClass('is-active');
        $target_block.velocity("slideUp", {duration: 450, easing: 'easeOutQuart'}).parent().removeClass('is-active');
        setTimeout(function () {
            $(document).trigger('collapseClosed', [$target_value]);
        }, 450)
    } else if ($(this).data('action') !== 'collapse') {
        $(document).trigger('collapseOpening', [$target_value]);
        $('[data-target="'+$target_value+'"]').addClass('is-active');
        $target_block.velocity("slideDown", {duration: 400, easing: 'easeOutQuart'}).parent().addClass('is-active');
        setTimeout(function () {
            $(document).trigger('collapseOpened', [$target_value]);
        }, 400)
    }
    return false;
});